import { Head, router } from "@inertiajs/react"

import HeadingSmall from "@/components/heading-small"
import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import {
  acceptSettingsTeamInvitationPath,
  declineSettingsTeamInvitationPath,
  settingsTeamInvitationsPath,
} from "@/routes"
import type { BreadcrumbItem, TeamInvitation } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  { title: "Invitations", href: settingsTeamInvitationsPath() },
]

interface Props {
  invitations: TeamInvitation[]
}

export default function Invitations({ invitations }: Props) {
  function handleAccept(id: number) {
    router.post(acceptSettingsTeamInvitationPath(id), undefined, {
      preserveScroll: true,
    })
  }

  function handleDecline(id: number) {
    if (!confirm("Are you sure you want to decline this invitation?")) return

    router.post(declineSettingsTeamInvitationPath(id), undefined, {
      preserveScroll: true,
    })
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Invitations" />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Team Invitations"
            description="Invitations to join a team"
          />

          {invitations.length === 0 ? (
            <p className="text-muted-foreground text-sm">
              No pending invitations.
            </p>
          ) : (
            <div className="space-y-3">
              {invitations.map((invitation) => (
                <div
                  key={invitation.id}
                  className="flex items-center justify-between rounded-lg border p-3"
                >
                  <div>
                    <p className="text-sm font-medium">
                      {invitation.team_name}
                    </p>
                    <p className="text-muted-foreground text-sm">
                      Invited by {invitation.team_owner_name}
                    </p>
                  </div>

                  <div className="flex gap-2">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => handleDecline(invitation.id)}
                    >
                      Decline
                    </Button>
                    <Button
                      size="sm"
                      onClick={() => handleAccept(invitation.id)}
                    >
                      Accept
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
